import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=5be64663&scoped=true&lang=html"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=5be64663&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be64663",
  null
  
)

export default component.exports